import { designSchema } from '@epilot/journey-logic-commons/src/schemas/v4'

import { selectPerJourneyById } from '../selectors/config'
import type { DesignChangedAction } from '../types/actions'

import { actionFactory } from './factory'

/**
 * Hydrates design for the given Journey.
 *
 * The design is either coming from the Design Builder API or message handlers
 * when running in the context of Preview or the Design Builder.
 */
export const designChanged = actionFactory<DesignChangedAction>(
  (state, { journeyId, design }) => {
    const perJourney = selectPerJourneyById(state, journeyId)

    if (!perJourney) throw new Error('Expected perJourney to be set')

    const parsed = designSchema.parse(design)

    perJourney.design = parsed
  },
  'designChanged'
)
